import { useEffect } from "react";
import { createPortal } from "react-dom";

type LoadingProps = {
  hiddenScroll?: boolean;
  message?: string;
};

export const Loading: React.FC<LoadingProps> = ({ 
  hiddenScroll = false,
  message 
}) => {
  useEffect(() => {
    if (hiddenScroll) {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflow = "hidden";
      }
      
      return () => {
        if (html) {
          html.style.overflow = "auto";
        }
      };
    }
  }, [hiddenScroll]);

  const content = (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/70 backdrop-blur-sm transition-all duration-200 ease-out"
      role="dialog"
      aria-modal="true"
      aria-label="Cargando contenido"
    >
      <div className="flex flex-col items-center gap-4 p-6 bg-white rounded-xl shadow-lg border border-gray-100">
        <div 
          className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"
          data-testid="spinner"
        />
        {message && (
          <p className="text-gray-600 text-sm font-medium animate-pulse">
            {message}
          </p>
        )}
      </div>
    </div>
  );

  return createPortal(content, document.body);
};
